import { render, staticRenderFns } from "./modalPrevisualizacion.vue?vue&type=template&id=55c725e6&scoped=true&"
import script from "./modalPrevisualizacion.vue?vue&type=script&lang=js&"
export * from "./modalPrevisualizacion.vue?vue&type=script&lang=js&"
import style0 from "./modalPrevisualizacion.vue?vue&type=style&index=0&id=55c725e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c725e6",
  null
  
)

export default component.exports